'use strict';

var Joi = require('joi');
var authMethods = require('../utils/authMethods.js');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var _Joi$string;
var LandingPageUserLogin = Joi__default["default"].object().keys({
  email: Joi__default["default"].string().email({
    tlds: {
      allow: false
    }
  }).allow(null).description('End user email'),
  phone: Joi__default["default"].string().allow(null).optional().description('End user phone number if they authed with SMS'),
  new_account: Joi__default["default"].boolean().required().description('Is user signing up when logging in'),
  paying: Joi__default["default"].boolean().required().description('Is user already a paying customer'),
  sign_in_method: (_Joi$string = Joi__default["default"].string()).valid.apply(_Joi$string, authMethods).optional().description('The auth method user used to log in'),
  form_id: Joi__default["default"].string().guid({
    version: ['uuidv4']
  }).allow(null).description('The id of the landing page in Hype Forms table'),
  theme_id: Joi__default["default"].string().guid({
    version: ['uuidv4']
  }).optional().allow(null).description('The id of the theme for this landing page'),
  has_password: Joi__default["default"].boolean().required().description('Is the user logging in with a password?'),
  otp_verified: Joi__default["default"].boolean().required().description('Is the user logging in via OTP?')
}).description('landing_page:user_login event attributes ').meta({
  name: 'LandingPageUserLogin',
  filename: 'landing_page:user_login.model'
});
var LandingPageUserLogin$1 = LandingPageUserLogin;

module.exports = LandingPageUserLogin$1;
//# sourceMappingURL=user_login.model.js.map
